import { useQuery } from '@tanstack/react-query';
import { DOCUMENT_TYPES_KEY } from 'src/utils/constants/queryKeys';
import { getDocumentTypes } from '../services/fn-api/Cases';

export const useGetDocumentTypes = () => {
  return useQuery({
    queryKey: [DOCUMENT_TYPES_KEY],
    queryFn: () => getDocumentTypes(),
  });
};
